import React from 'react'

import View from '../../../../../components/pdf/View'
import Text from '../../../../../components/pdf/Text'
import Separator from '../../../../../components/pdf/Separator'
import { useFormReply } from '../../_load/FormReplyLoader'
import Image from '../../../../../components/pdf/Image'
import { findReplyByQuestionId, getImages } from '../../_helpers/pdfHelpers'

const Grid = ({ templateId }) => {
  const { replies } = useFormReply()

  const image = [9, 10, 11, 12, 13, 14, 15, 16].includes(templateId)
    ? getImages(findReplyByQuestionId(replies, 321))
    : getImages(findReplyByQuestionId(replies, 131))

  return (
    <View>
      <Text bold size="small" align="center">
        ANEXOS
      </Text>
      <Separator weight={4} />
      <Image style={{ margin: 'auto' }} maxHeight={850} src={image[0].src} ignoreFixedSize />
      <Separator weight={8} />
    </View>
  )
}

export default Grid
